var defaultConfig = {
  theme: 'default',
  view: {
    menu: true,
    md: true,
    html: true
  },
  canView: {
    menu: true,
    md: true,
    html: true,
    both: true,
    fullScreen: true,
    hideMenu: true
  },
  htmlClass: '',
  markdownClass: '',
  syncScrollMode: ['rightFollowLeft', 'leftFollowRight'],
  imageUrl: '',
  imageAccept: '',
  linkUrl: '',
  table: {
    maxRow: 4,
    maxCol: 6
  },
  allowPasteImage: true,
  onImageUpload: undefined,
  onCustomImageUpload: undefined,
  shortcuts: true
};
export default defaultConfig;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-markdown-editor-lite/esm/editor/defaultConfig.js
// module id = 1476
// module chunks = 0